class InfiniteScrollCollection extends HTMLElement {
  constructor() {
    super();
    this.currentPage = parseInt(this.dataset.currentPage) || 1;
    this.totalPages = parseInt(this.dataset.totalPages) || 1;
    this.sectionId = this.dataset.id;
    this.isLoading = false;
    this.observer = null;

    if (this.currentPage < this.totalPages) {
      this.init();
    }
  }

  init() {
    const sentinel = this.querySelector('.infinite-scroll-sentinel');
    if (!sentinel) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isLoading) {
            this.loadNextPage();
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0 }
    );

    this.observer.observe(sentinel);
  }

  async loadNextPage() {
    if (this.isLoading || this.currentPage >= this.totalPages) return;

    this.isLoading = true;
    this.showLoader();

    const nextPage = this.currentPage + 1;
    const url = `${window.location.pathname}?page=${nextPage}&section_id=${this.sectionId}`;

    try {
      const response = await fetch(url);
      const html = await response.text();

      this.appendProducts(html);
      this.currentPage = nextPage;

      if (this.currentPage >= this.totalPages) {
        this.cleanup();
      }
    } catch (error) {
      console.error('Infinite scroll error:', error);
    } finally {
      this.isLoading = false;
      this.hideLoader();
    }
  }

  appendProducts(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Check for type-grouped sections
    const newTypeSections = doc.querySelectorAll('.product-type-section');

    if (newTypeSections.length > 0) {
      newTypeSections.forEach(newSection => {
        const typeAttr = newSection.getAttribute('data-type');
        const existingSection = this.querySelector(`.product-type-section[data-type="${CSS.escape(typeAttr)}"]`);

        if (existingSection) {
          // Append products to existing type grid
          const existingGrid = existingSection.querySelector('[data-type-grid]');
          const newGrid = newSection.querySelector('[data-type-grid]');

          if (existingGrid && newGrid) {
            Array.from(newGrid.children).forEach(child => {
              existingGrid.appendChild(child.cloneNode(true));
            });
          }
        } else {
          // New type section — insert before sentinel
          const container = this.querySelector('#CollectionProductGrid');
          const sentinel = this.querySelector('.infinite-scroll-sentinel');
          const loader = this.querySelector('.infinite-scroll-loading');
          const insertBefore = loader || sentinel;

          if (insertBefore) {
            container.insertBefore(newSection.cloneNode(true), insertBefore);
          } else {
            container.appendChild(newSection.cloneNode(true));
          }

          // Update type nav if new section appeared
          this.updateTypeNav(newSection);
        }
      });
    } else {
      // Flat grid fallback (no type blocks)
      const newGrid = doc.querySelector('.product-grid-border-fix');
      const existingGrid = this.querySelector('.product-grid-border-fix');

      if (newGrid && existingGrid) {
        Array.from(newGrid.querySelectorAll('.box__collection')).forEach(product => {
          existingGrid.appendChild(product.cloneNode(true));
        });
      }
    }

    // Trigger theme's lazy image loading
    if (window.customElements && document.querySelector('.mount-images')) {
      document.dispatchEvent(new CustomEvent('shopify:section:load', {
        detail: { sectionId: this.sectionId }
      }));
    }
  }

  updateTypeNav(newSection) {
    const nav = document.querySelector('type-navigation-bar');
    if (nav && nav.rescanSections) {
      nav.rescanSections();
    }
  }

  showLoader() {
    const sentinel = this.querySelector('.infinite-scroll-sentinel');
    if (!sentinel) return;

    let loader = this.querySelector('.infinite-scroll-loading');
    if (!loader) {
      loader = document.createElement('div');
      loader.className = 'infinite-scroll-loading';
      loader.innerHTML = '<div class="infinite-scroll-spinner"></div>';
      sentinel.parentNode.insertBefore(loader, sentinel);
    }
    loader.style.display = 'flex';
  }

  hideLoader() {
    const loader = this.querySelector('.infinite-scroll-loading');
    if (loader) {
      loader.style.display = 'none';
    }
  }

  cleanup() {
    const sentinel = this.querySelector('.infinite-scroll-sentinel');
    if (sentinel) sentinel.remove();

    const loader = this.querySelector('.infinite-scroll-loading');
    if (loader) loader.remove();

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

customElements.define('infinite-scroll-collection', InfiniteScrollCollection);

/* Ensure filter bar has inner wrapper for two-layer scroll pattern.
   The Liquid template outputs the wrapper, but CDN may serve cached HTML without it. */
(function() {
  document.querySelectorAll('.type-filter-bar').forEach(function(bar) {
    if (!bar.querySelector('.type-filter-bar__inner')) {
      var inner = document.createElement('div');
      inner.className = 'type-filter-bar__inner';
      while (bar.firstChild) inner.appendChild(bar.firstChild);
      bar.appendChild(inner);
    }
  });
})();
